import gqlRequest from 'graphql/generic';
import { Message, Party } from '../types';

type GetOrderMessages = {
  getOrderMessages: Message[];
};

type GetOrderMessagesParams = {
  id: string;
};

const query = `
  query GetOrderMessages($id: ID!) {
    getOrderMessages(_id: $id) {
      _id
      datetime
      sender
      status
      reply_to
      subject
      from
      to
      cc
      bcc
      content
      receptions
    } 
  }
`;

export const getOrderMessages = (id: string) =>
  gqlRequest<GetOrderMessages, GetOrderMessagesParams>(query, { id });

type GetOrder = {
  getOrder: {
    parties: Party[];
  };
};

type GetOrderParams = {
  id: string;
};

const queryGetOrder = `
  query GetOrder($id: ID!) {
    getOrder(_id: $id) {
      parties {
        _id
        name
        kinds
        emails {
          _id
          address
          kind
        }
      }
    } 
  }
`;

export const getOrder = (id: string) => gqlRequest<GetOrder, GetOrderParams>(queryGetOrder, { id });
